import {
  Select as DesignSystemSelect,
  SelectProps,
} from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * MED-1457 — the design system's Select falls back to a hardcoded English
 * "Select an option..." when no placeholder is given, which surfaced on a
 * French UI (the onboarding "Type d'établissement" field, among others). The
 * default lives in the published package, so the admin cannot change it at
 * its own source; this wrapper supplies the translated default instead, for
 * every Select in the app at once. An explicit `placeholder` still wins.
 */
export const Select = React.forwardRef<
  HTMLDivElement,
  SelectProps<unknown> & React.RefAttributes<HTMLDivElement>
>(({ placeholder, ...props }, ref) => {
  const { t } = useTranslation();
  return (
    <DesignSystemSelect
      ref={ref}
      placeholder={placeholder ?? t("common.selectOption")}
      {...props}
    />
  );
});

Select.displayName = "Select";
